import { render, staticRenderFns } from "./CardDetalhesComprador.vue?vue&type=template&id=2e7bde85"
import script from "./CardDetalhesComprador.vue?vue&type=script&lang=js"
export * from "./CardDetalhesComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports